import { storeAsync } from '@/app-module';

export default {
  async beforeRouteEnter(to, from, next) {
    if (!to.meta || !to.meta.unauth) {
      next();
      return;
    }

    const store = storeAsync();
    let currentUser = localStorage.getItem('currentUser');
    if (currentUser) {
      await store.dispatch('auth/doWaitUntilInit');
    }
    // await storeAsync().dispatch('auth/doWaitUntilInit');

    
    if (storeAsync().getters['auth/signedIn']) {
      next('/');
    } else {
      next();
    }
  },
};
